<template>
  <div class="grid grid-cols-12 items-center gap-3 mb-5">
    <div class="text-right col-span-3">
      {{ t('Name') }}
    </div>
    <div class="col-span-9">
      <TextboxField :type="'text'" :name="'label'" v-model="customField.label" :isRequired="true" />
    </div>

    <div class="text-right col-span-3">
      {{ t('weight_measurement.apiKey') }}
    </div>
    <div class="col-span-9">
      <TextboxField v-if="shouldAllowInputApiKey" :name="'apiKey'" v-model="customField.apiKey" :isRequired="true" />
      <div v-else class="flex items-center gap-2">
        <el-input placeholder="xxxx-xxxx-xxxx-xxxx" :disabled="true" />
        <el-button type="primary" @click="handleUnlockApiKey">{{
          t('weight_measurement.unlockChangingApiKey')
        }}</el-button>
      </div>
    </div>

    <div class="text-right col-span-3">
      {{ t('weight_measurement.deviceId') }}
    </div>
    <div class="col-span-9">
      <TextboxField :name="'deviceId'" v-model="customField.deviceId" :isRequired="true" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import { useI18n } from 'vue-i18n'
import { IProjectCustomField } from '@/utils/types'

@Options({
  components: { TextboxField },
  name: 'Textbox',
})
export default class WeightMeasurement extends Vue {
  @Prop({ type: Object }) readonly customField!: IProjectCustomField
  isLockedChangingApiKey = false
  private t = useI18n().t
  created() {
    this.isLockedChangingApiKey = !!this.customField.hasEncryptedApiKey && this.customField.apiKey === ''
  }

  handleUnlockApiKey() {
    this.isLockedChangingApiKey = false
  }

  get shouldAllowInputApiKey() {
    return !this.isLockedChangingApiKey
  }
}
</script>
